import HttpService from "./httpService";

// A key as returned by the listing endpoint — never includes the secret itself,
// only enough to identify it in the UI.
export interface IntegrationKey {
  _id: string;
  entityId: number;
  provider: string;
  last4: string;
  label?: string;
  status: "active" | "revoked";
  lastUsedAt?: string;
  createdAt: string;
  revokedAt?: string;
}

// Returned once by create/rotate — `key` is the raw secret and is never
// retrievable again, so the UI must surface it immediately.
export interface CreatedIntegrationKey {
  id: string;
  key: string;
  last4: string;
  label?: string;
  provider: string;
  status: string;
  createdAt: string;
}

class IntegrationService {
  listKeys = async () => {
    return HttpService.get<IntegrationKey[]>("/integration-keys");
  };

  createKey = async (label?: string) => {
    return HttpService.post<CreatedIntegrationKey>("/integration-keys", { label });
  };

  rotateKey = async (id: string) => {
    return HttpService.post<CreatedIntegrationKey>(`/integration-keys/${id}/rotate`, {});
  };

  revokeKey = async (id: string) => {
    return HttpService.delete<{ message: string }>(`/integration-keys/${id}`);
  };
}

export const integrationService = new IntegrationService();
